import { Injectable } from '@angular/core';
import { Store, StoreConfig } from '@datorama/akita';
import { LASER_SHOT, UNIQUE_RESTRICTIONS } from '@core/settings';

export interface SettingsState {
    key: string;
    appUser: boolean;
    cabinetRequiresDCD: boolean;
    cabinetRequiresShot: LASER_SHOT;
    cabinetSkip: boolean;
    clientAddressSplit: boolean;
    clientCustomFieldsEnable: string;
    clientCustomFieldsLabels: string;
    clientCustomFieldsTypes: string;
    clientEditRequiredFields: string;
    clientLegalRepAge: number;
    clientPicturesDownscale: boolean;
    clientHideFields: string;
    clientNewFields: string;
    clientNewRequiredFields: string;
    clientValidateAppRequiredFields: string;
    combineFactor: string;
    diaryFutureValidate: boolean;
    fwaUserMode: boolean;
    laserSignEnabled: boolean;
    maxServices: number;
    nameSplit: boolean;
    orders: boolean;
    productsPack: boolean;
    requiredSelectUser: boolean;
    settingsLoaded: boolean;
    stock: boolean;
    subscriptions: boolean;
    timeSlot: number;
    duplicateMailUnique: UNIQUE_RESTRICTIONS;
    duplicateDniUnique: UNIQUE_RESTRICTIONS;
    duplicatePhoneUnique: UNIQUE_RESTRICTIONS;
    RGPDDisable: boolean;
    visualDoctor: boolean;
    clientPrescription: boolean;
    appNotAssisted: boolean;
    appNotAssistedFuture: boolean;
    voucherPackAuto: boolean;
    traceabilityIsActive: boolean;
    diaryTypeProfessional: boolean;
}

export function createInitialState(): SettingsState {
    return {
        key: '',
        appUser: false,
        cabinetRequiresDCD: false,
        cabinetRequiresShot: LASER_SHOT.ACTIVATED_FIELDS,
        cabinetSkip: false,
        clientAddressSplit: false,
        clientCustomFieldsEnable: '',
        clientCustomFieldsLabels: '',
        clientCustomFieldsTypes: '',
        clientEditRequiredFields: '',
        clientLegalRepAge: 0,
        clientHideFields: '',
        clientNewFields: '',
        clientNewRequiredFields: '',
        clientPicturesDownscale: false,
        clientValidateAppRequiredFields: '',
        combineFactor: '',
        diaryFutureValidate: false,
        fwaUserMode: false,
        laserSignEnabled: false,
        maxServices: Infinity,
        nameSplit: false,
        orders: false,
        productsPack: false,
        requiredSelectUser: false,
        settingsLoaded: false,
        stock: true,
        subscriptions: false,
        timeSlot: 0,
        duplicateMailUnique: UNIQUE_RESTRICTIONS.NONE,
        duplicateDniUnique: UNIQUE_RESTRICTIONS.NONE,
        duplicatePhoneUnique: UNIQUE_RESTRICTIONS.NONE,
        RGPDDisable: false,
        visualDoctor: false,
        clientPrescription: false,
        appNotAssisted: false,
        appNotAssistedFuture: false,
        voucherPackAuto: false,
        traceabilityIsActive: false,
        diaryTypeProfessional: false,
    };
}

@Injectable({ providedIn: 'root' })
@StoreConfig({ name: 'settings', resettable: true })
export class SettingsStore extends Store<SettingsState> {
    constructor() {
        super(createInitialState());
    }
}
